import HTTPStatus from "http-status";
import {
  INTRODUCCIO_OMPLIR_DATA,
  INTRODUCCIO_OMPLIR_ID_OBSERVADOR,
  INTRODUCCIO_OBTENIR_DADES,
  INTRODUCCIO_CREAR_FOTO_FENOFASE_INDIVIDU_EN_CURS,
  INTRODUCCIO_CREAR_FOTO_FENOFASE_INDIVIDU_FINALITZADA,
  INTRODUCCIO_ESBORRAR_FOTO_FENOFASE_INDIVIDU_EN_CURS,
  INTRODUCCIO_ESBORRAR_FOTO_FENOFASE_INDIVIDU_FINALITZADA,
  INTRODUCCIO_SHOW_COMMENT,
  ESBORRAR_COMENTARIS,
  INTRODUCCIO_OMPLIR_ID_ESPECIE
} from "./actionTypes";
import { errorConsultaServidor } from "./error";
import {
  fetchDadesIntroduccio,
  fetchCrearFotoFenofaseIndividu,
  fetchEliminarFotoFenofaseIndividu
} from "./consultesServidor";
import {
  crearNotificacioSuccess,
  crearNotificacioWarning,
  crearNotificacioError
} from "../utils/notificacio";
import {
  getIdObservadorIntroduccio,
  getDataIntroduccioAsMoment
} from "../reducers";
export const omplirDataIntroduccio = data => ({
  type: INTRODUCCIO_OMPLIR_DATA,
  payload: data
});

export const omplirIdObservadorIntroduccio = idObservador => ({
  type: INTRODUCCIO_OMPLIR_ID_OBSERVADOR,
  payload: idObservador
});

export const obtenirDadesIntroduccio = idObservador => {
  return (dispatch, getState) => {
    const state = getState();
    const dia = getDataIntroduccioAsMoment(state);
    const idObservadorState = getIdObservadorIntroduccio(state);
    const idObservadorCerca = idObservadorState || idObservador;
    return dispatch({
      type: INTRODUCCIO_OBTENIR_DADES,
      promise: fetchDadesIntroduccio(dia, idObservadorCerca)
    });
  };
};

/**
 * Quan el servidor retorna que la petició s'ha executat correctament, es tracten
 * els possibles casos d'estat d'aquesta: OK, PARTIAL_CONTENT i ERROR.
 * En el nostre cas s'ha usat el PARTIAL_CONTENT en el cas de les fotografies.
 *
 * @param resposta {Object}, configuracioNotificacions {Object}
 * @returns {*}
 */
const mostrarNotificacioAPartirDeRespostaServidor = (
  resposta,
  configuracioNotificacions
) => {
  switch (resposta.status) {
    case HTTPStatus.OK: {
      crearNotificacioSuccess(configuracioNotificacions.exit);
      break;
    }
    case HTTPStatus.PARTIAL_CONTENT: {
      crearNotificacioWarning(
        configuracioNotificacions.advertencia.titol,
        configuracioNotificacions.advertencia.descripcio
      );
      break;
    }
    default: {
      console.warn(`Error de tipus ${resposta.status}: ${resposta.body}`);
      crearNotificacioError(configuracioNotificacions.error);
    }
  }
};

/**
 * S'Crea la foto fenofase d'individu
 * @param foto {Object}
 * @returns {{type, foto}|*}
 */
export const introduccioCrearFotoFenofaseIndividu = foto => {
  return dispatch => {
    const idFenofase = foto.idFenofase;
    const idIndividu = foto.idIndividu;

    let promesa;
    let configuracioNotificacions;

    let formData = new FormData();
    const dadesPath = {
      idFenofase: idFenofase,
      idIndividu: idIndividu
    };
    formData.append("dades", JSON.stringify(dadesPath));
    formData.append("foto", foto.fitxer);

    dispatch(introduccioCrearFotoFenofaseIndividuEnCurs());
    promesa = fetchCrearFotoFenofaseIndividu(formData);

    const notificacioCrearFotoFenofaseExit =
      "Foto fenofase individu creada correctament";
    const notificacioCrearFotoFenofaseAdvertencia = {
      titol: notificacioCrearFotoFenofaseExit,
      descripcio: "La foto no s'ha pogut inserir."
    };
    const notificacioCrearFotoFenofaseError = "Error creant la foto";

    configuracioNotificacions = {
      exit: notificacioCrearFotoFenofaseExit,
      advertencia: notificacioCrearFotoFenofaseAdvertencia,
      error: notificacioCrearFotoFenofaseError
    };

    return promesa.then(
      resposta => {
        dispatch(introduccioCrearFotoFenofaseIndividuFinalitzada());
        mostrarNotificacioAPartirDeRespostaServidor(
          resposta,
          configuracioNotificacions
        );
        dispatch(obtenirDadesIntroduccio());
      },
      errorServidor => {
        dispatch(introduccioCrearFotoFenofaseIndividuFinalitzada());
        dispatch(
          errorConsultaServidor(errorServidor, configuracioNotificacions.error)
        );
      }
    );
  };
};

/**
 * S'elimina la foto fenofase d'individu
 * @param foto {Object}
 * @returns {{type, foto}|*}
 */
export const introduccioEliminarFotoFenofaseIndividu = foto => {
  return dispatch => {
    let promesa;
    let configuracioNotificacions;

    dispatch(introduccioEsborrarFotoFenofaseIndividuEnCurs());
    promesa = fetchEliminarFotoFenofaseIndividu(foto);

    const notificacioCrearFotoFenofaseExit =
      "Foto fenofase individu esborrada correctament.";
    const notificacioCrearFotoFenofaseAdvertencia = {
      titol: notificacioCrearFotoFenofaseExit,
      descripcio: "La foto no s'ha pogut esborrar."
    };
    const notificacioCrearFotoFenofaseError = "Error esborrant la foto.";

    configuracioNotificacions = {
      exit: notificacioCrearFotoFenofaseExit,
      advertencia: notificacioCrearFotoFenofaseAdvertencia,
      error: notificacioCrearFotoFenofaseError
    };

    return promesa.then(
      resposta => {
        dispatch(introduccioEsborrarFotoFenofaseIndividuFinalitzada());
        mostrarNotificacioAPartirDeRespostaServidor(
          resposta,
          configuracioNotificacions
        );
        dispatch(obtenirDadesIntroduccio());
        return resposta;
      },
      errorServidor => {
        dispatch(introduccioEsborrarFotoFenofaseIndividuFinalitzada());
        dispatch(
          errorConsultaServidor(errorServidor, configuracioNotificacions.error)
        );
        crearNotificacioError(configuracioNotificacions.error);
        return errorServidor;
      }
    );
  };
};

/**
 * Indica que la petició per inserir foto fenofase
 * està en curs.
 *
 * @returns {Object}
 */
const introduccioCrearFotoFenofaseIndividuEnCurs = () => {
  return {
    type: INTRODUCCIO_CREAR_FOTO_FENOFASE_INDIVIDU_EN_CURS
  };
};

/**
 * Indica que la petició per per inserir foto fenofase
 * ha finalitzat.
 *
 * @returns {Object}
 */
const introduccioCrearFotoFenofaseIndividuFinalitzada = () => {
  return {
    type: INTRODUCCIO_CREAR_FOTO_FENOFASE_INDIVIDU_FINALITZADA
  };
};

/**
 * Indica que la petició per inserir foto fenofase
 * està en curs.
 *
 * @returns {Object}
 */
const introduccioEsborrarFotoFenofaseIndividuEnCurs = () => {
  return {
    type: INTRODUCCIO_ESBORRAR_FOTO_FENOFASE_INDIVIDU_EN_CURS
  };
};

/**
 * Indica que la petició per per inserir foto fenofase
 * ha finalitzat.
 *
 * @returns {Object}
 */
const introduccioEsborrarFotoFenofaseIndividuFinalitzada = () => {
  return {
    type: INTRODUCCIO_ESBORRAR_FOTO_FENOFASE_INDIVIDU_FINALITZADA
  };
};

export const introduccioMostrarComentari = idIndividuFenofase => ({
  type: INTRODUCCIO_SHOW_COMMENT,
  payload: idIndividuFenofase
});

export const esborrarComentaris = (idIndividuFenofase, opcio) => {
  return {
    type: ESBORRAR_COMENTARIS,
    payload: { idIndividuFenofase: idIndividuFenofase, valor: opcio }
  };
};

export const omplirIdEspecieIntroduccio = idEspecie => ({
  type: INTRODUCCIO_OMPLIR_ID_ESPECIE,
  payload: idEspecie
});
